import { ReactNode } from 'react'

const strings = {
  title: 'Поименно: 34 жертвы майских событий в Хороге и Рушане',
  menu: {
    about: 'Подробнее',
    share: 'Поделиться',
    introduction: 'ВВЕДЕНИЕ',
  },
  footer: {
    followUs: 'Подпишитесь на нас',
    copyright: '© 2022 Радио Озоди | Все права защищены',
    contentTitle: 'О нас',
    content: `Радио Озоди публикует информацию, которую невозможно найти в официальных СМИ, а другие местные издания, как правило, воздерживаются от ее распространения. Таджикская служба Радио Свобода (Радио Озоди) – одна из редакций медиакорпорации Радио Свободная Европа/Радио Свобода (РСЕ/РС). Медиакорпорация в качестве частного грантополучателя финансируется за счет средств, предоставляемых Конгрессом США через попечителя американского зарубежного вещания, Агентство США по глобальным медиа (USAGM). Американским официальным, правительственным и партийным лицам, включая руководителя USAGM, запрещено вмешиваться в вопросы редакционной политики. `,
    creatorsTitle: 'Над проектом работали',
    creators: (
      <p>
        <strong>Автор:</strong> Радио Озоди
        <br />
        <strong>Дизайн и верстка:</strong> Pangea Digital Dataviz team – Ольга
        Барышникова, Ян Хоффман, Якуб Сиротек, Денис Артамонов
      </p>
    ),
  },
  home: {
    title: (
      <>
        <span>Поименно:</span> 34 жертвы майских событий в Хороге и Рушане
      </>
    ),
    khorog: 'Хорог',
    khorug: 'Хорог',
    rushon: 'Рушан',
    rushan: 'Рушан',
    map: {
      popupTemplate: (date: string, people: number, city: string) =>
        `On ${date} at least ${people} people were known to have been killed in the crackdown in ${city}`,
      popups: [
        'Точную дату гибели 17 жителей Рушана пока установить не удалось. По словам близких, они, вероятнее всего, были убиты 18 мая 2022 года, однако тела были найдены позднее.',
        '31 мая 2022 года в Рушанском районе были убиты 5 человек.',
        'Близкие 4 жертв сообщили точную дату их гибели – 18 мая. Местные жители убеждены, что в тот день было убито много людей, но тела были найдены позднее.',
        'По данным близких, в Рушане 19 мая были убиты не менее трех человек.',
        'В ходе акции протеста в Хороге были убит еще один местный житель, точная дата смерти неизвестна.',
        '12 июня 2022 года в Хороге были убиты двое местных жителей.',
        '22 мая в Хороге, административном центре ГБАО, был убит один человек.',
        '16 мая, в первый день акции протеста недовольной молодежи в Хороге, правоохранительными органами был убит один человек.',
      ],
      mayShort: 'Май',
      juneShort: 'Июнь',
      unknownDate: 'неизвестно',
    },
    postedOn: '',
    updated: 'Обновлено:',
    seeTheirStories: 'Прочтите их истории…',
    listTitle: 'Рӯйхати пурра',
    noResults: 'Ничего не найдено',
    filterByAge: 'Сортировка по возрасту',
    filterByPlaceOfBirth: 'Сортировка по месту рождения',
    allVictims: 'Все жертвы',
    chartCaption: `В событиях в Хороге и Рушане погибли люди разных возрастов.
    Здесь приведены сведения о дате рождения жертв событий (сведения
    предоставлены близкими родственниками или осведомленными лицами). `,
  },
  detail: {
    backButton: 'НАЗАД',
    previousButton: 'ПРЕДЫДУЩИЙ',
    nextButton: 'СЛЕДУЮЩИЙ',
    years: (v: ReactNode) => `${v} лет`,
    seeAdditionalInfo: 'Больше информации',
  },
}

export default strings
